export const getEnvironmentVariable = () => process.env.NODE_ENV
